
import React, { Component } from 'react';
import './HLASAnimatedWait.scss';



class HLASAnimatedWait extends Component {

    
    

    componentDidMount(){
        
    }

    
        
    render() {
        /**/
        
        return (
            

            <div className={"hlas-component animatedWait " + (this.props.active ? "active" : "")}>
                <div className={this.props.mode}>
                    <div className={"animatedLoader-wrap"}>
                        <div className={"animatedloader"}></div>
                        {this.props.message && (<div className="animatedLoader-message-wrapper"><br /><span className="animatedLoader-message">{this.props.message}</span></div>)}
                    </div>
                
                    
                </div>
            </div>
        );

    }
}


HLASAnimatedWait.defaultProps = {
    mode : "fullscreen"
};

export default HLASAnimatedWait;